import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';
import ScaleQuestionForm from './ScaleQuestionForm';
import TextQuestionRichText from '../../../domains/richText/components/TextQuestionRichText';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

const ScaleQuestion = ({
  block,
  block: { clientUuid, content, required },
  onAnswer,
  answer,
  styling,
  questionNumber,
  isCloned,
  isInPreviewMode = false,
}) => {
  const isConditionalQuestion = useMemo(() => !!(block.logic && block.logic.message), [block.logic]);

  return (
    <div>
      {isInPreviewMode &&
        isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
      <TextQuestionRichText
        questionNumber={questionNumber}
        content={content}
        required={required}
        styling={styling}
      />
      <ScaleQuestionForm
        form={generateQuestionFormName(clientUuid, isCloned)}
        block={block}
        onSubmit={onAnswer}
        initialValues={answer}
        styling={styling}
      />
    </div>
  );
};

ScaleQuestion.propTypes = {
  block: PropTypes.shape({
    clientUuid: PropTypes.string.isRequired,
    required: PropTypes.bool,
    content: PropTypes.object,
  }).isRequired,
  isCloned: PropTypes.bool,
  isInPreviewMode: PropTypes.bool,
  onAnswer: PropTypes.func.isRequired,
  answer: PropTypes.shape({
    value: PropTypes.number,
    comments: PropTypes.string,
  }),
  styling: propTypeBlockStyling,
  questionNumber: PropTypes.number,
};

export default ScaleQuestion;
